import { useContextSelector } from 'use-context-selector'

import { TurnListContext } from '../context/TurnListProvider'

export const useWaitingList = () => {
  const moveOutOfStoreItemToWaitingList = useContextSelector(
    TurnListContext,
    (turnList) => turnList.moveOutOfStoreItemToWaitingList
  )

  return {
    moveOutOfStoreItemToWaitingList,
  }
}
